import React, { useContext } from 'react';
import TopInfluencerComponent from './TopInfluencerComponent';
import TopPerformingInfluencersComponent from './TopPerformingInfluencersComponent';
import { UserContext } from '@/context/UserContext';
import { useCreatorAnalysisQuery } from '@/hooks/queries/useAnalyticsQueries';
import { useDateRangeQueryParams } from '@/hooks/useDateRangeQueryParams';
import Loading from '../Loading';

const InfluencersTabComponent = ({ dateFilteredData }: any) => {
  const userContext = useContext(UserContext);
  if (!userContext) {
    throw new Error('useContext must be used within a UserProvider');
  }
  const { user, isDummyUser } = userContext;

  const brandId = user?.brand?._id || '';

  const { filter, customStartDate, customEndDate } =
    useDateRangeQueryParams(dateFilteredData);

  const { data: creatorData, isLoading } = useCreatorAnalysisQuery(
    brandId,
    filter,
    !isDummyUser && user?.role === 'brandUser' && !!filter && !!brandId,
    customStartDate,
    customEndDate,
  );

  const topInfluencers = creatorData?.topCreator || {};
  // The top creator is also creators[0] in the reach-sorted list; drop it from
  // the table below so it isn't shown twice.
  const topCreatorUserId = creatorData?.topCreator?.user?.userId;
  const topPerformingInfluencers = (creatorData?.creators || []).filter(
    (creator: any) => String(creator?.userId) !== String(topCreatorUserId),
  );

  return (
    <div className="flex flex-col gap-6">
      {isLoading ? (
        <Loading
          centeredToParent={true}
          style={{
            top: 'calc(50% + 60px)',
          }}
        />
      ) : (
        <>
          <TopInfluencerComponent
            topInfluencers={topInfluencers}
            filter={filter}
          />
          <TopPerformingInfluencersComponent
            topPerformingInfluencers={topPerformingInfluencers}
          />
        </>
      )}
    </div>
  );
};

export default InfluencersTabComponent;
